webpackJsonp([66013065545312],{

/***/ 89:
/***/ (function(module, exports) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	  name: true,
	  length: true,
	  prototype: true,
	  caller: true,
	  callee: true,
	  arguments: true,
	  arity: true
	};
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	
	module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	
	        if (objectPrototype) {
	            var inheritedComponent = getPrototypeOf(sourceComponent);
	            if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	            }
	        }
	
	        var keys = getOwnPropertyNames(sourceComponent);
	
	        if (getOwnPropertySymbols) {
	            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                try { // Avoid failures from read-only properties
	                    defineProperty(targetComponent, key, descriptor);
	                } catch (e) {}
	            }
	        }
	
	        return targetComponent;
	    }
	
	    return targetComponent;
	};


/***/ }),

/***/ 37:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var lang = '';
	
	exports.lang = lang;

/***/ }),

/***/ 183:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(86);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _language = __webpack_require__(37);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ContentSectionHeader = function (_React$Component) {
	  _inherits(ContentSectionHeader, _React$Component);
	
	  function ContentSectionHeader() {
	    _classCallCheck(this, ContentSectionHeader);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  ContentSectionHeader.prototype.render = function render() {
	    var intro = this.props.intro;
	    var handleImageLoaded = this.props.handleImageLoaded;
	
	    return _react2.default.createElement(
	      'header',
	      { className: 'section-header' },
	      _react2.default.createElement(
	        'h1',
	        { className: 'section-title' },
	        intro['title' + _language.lang]
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'section-description' },
	        intro['description' + _language.lang]
	      ),
	      intro.image && _react2.default.createElement('img', { className: 'section-image', onLoad: handleImageLoaded, src: ("/guides/ocelli-ocellus/en") + '/' + intro.url + '/' + intro.image + '.png' }),
	      _react2.default.createElement(
	        'p',
	        { className: 'section-show', onClick: this.unfold },
	        _react2.default.createElement(
	          'i',
	          { className: 'material-icons' },
	          'keyboard_arrow_down'
	        )
	      )
	    );
	  };
	
	  ContentSectionHeader.prototype.unfold = function unfold() {
	    document.querySelector('.section-show').classList.remove('state-active');
	    document.querySelector('.section-header').classList.add('state-active');
	  };
	
	  return ContentSectionHeader;
	}(_react2.default.Component);
	
	var ContentSection = function (_React$Component2) {
	  _inherits(ContentSection, _React$Component2);
	
	  function ContentSection() {
	    _classCallCheck(this, ContentSection);
	
	    return _possibleConstructorReturn(this, _React$Component2.apply(this, arguments));
	  }
	
	  ContentSection.prototype.render = function render() {
	    var data = this.props.data;
	    console.log(data);
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(ContentSectionHeader, {
	        intro: data.allTranslationsXlsxSections.edges[0].node,
	        handleImageLoaded: this.handleImageLoaded.bind(this)
	      }),
	      data.allTranslationsXlsxContent.edges.map(function (_ref, index) {
	        var node = _ref.node;
	        return _react2.default.createElement(
	          'article',
	          { className: 'setting', key: index },
	          _react2.default.createElement(
	            'p',
	            { className: 'setting__title' },
	            _react2.default.createElement(
	              'span',
	              { className: 'setting__number' },
	              index + 1,
	              '.'
	            ),
	            ' ',
	            node['setting' + _language.lang]
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'setting__description' },
	            node['description' + _language.lang]
	          ),
	          node.image && _react2.default.createElement('img', { className: 'setting__image', src: ("/guides/ocelli-ocellus/en") + '/' + node.key + '/' + node.image + '.png' })
	        );
	      })
	    );
	  };
	
	  ContentSection.prototype.handleImageLoaded = function handleImageLoaded() {
	    var showElem = document.querySelector('.section-show');
	    var headerPos = document.querySelector('.section-header').getBoundingClientRect();
	    var imagePos = document.querySelector('.section-image').getBoundingClientRect();
	
	    headerPos.height < imagePos.height && showElem.classList.add('state-active');
	  };
	
	  return ContentSection;
	}(_react2.default.Component);
	
	exports.default = ContentSection;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-content-section-js-757edb207279f5c21c46.js